/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { type NativeLinkProps, type RenderFn } from '@atlassian/forge-ui-types';
import { useContext, Fragment } from 'react';
import { RendererContext } from '../../../context';
import { useNavigation } from '../../../custom-ui/bridge/methods/useNavigation';
import { sanitizeUrl } from '../../../utils/sanitizeUrl';
import { fg } from '@atlaskit/platform-feature-flags';

const LinkOld = (props: Parameters<RenderFn>[0]) => {
	const { forgeDoc, render } = props;
	const { href, openNewTab } = forgeDoc.props as NativeLinkProps;

	return (
		<a
			target={openNewTab ? '_blank' : undefined}
			href={sanitizeUrl(href)}
			rel="noopener noreferrer"
		>
			{forgeDoc.children.map(render)}
		</a>
	);
};
const LinkNew = (props: Parameters<RenderFn>[0]) => {
	const { egress, properties } = useContext(RendererContext);
	const { forgeDoc, render } = props;
	const { href, openNewTab } = forgeDoc.props as NativeLinkProps;
	const extension = { egress, properties };
	const { onNavigate, getModalJsx } = useNavigation({ extension });

	const santizedUrl = sanitizeUrl(href);

	return (
		<Fragment>
			{getModalJsx()}
			<a
				target={openNewTab ? '_blank' : undefined}
				href={santizedUrl}
				onClick={(e) => {
					// stop the usual navigation event from anchor tags
					e.preventDefault();
					onNavigate({ type: openNewTab ? 'new-tab' : 'same-tab', url: santizedUrl });
				}}
				rel="noopener noreferrer"
			>
				{forgeDoc.children.map(render)}
			</a>
		</Fragment>
	);
};

export const Link = (props: Parameters<RenderFn>[0]) => {
	return fg('ui-kit-link-egress-patch') ? <LinkNew {...props} /> : <LinkOld {...props} />;
};
